import { AvailabilityDto } from './availability-dto';

export interface WeekAvailabilityDto {
  available: AvailabilityDto[];
  in_store_zone: boolean;
  in_vehicle_zone: boolean;
  week?: number;
  year?: number;
  /**
   * The charity requires the donor to be inside a zone this donor's zip falls outside of.
   * The API also returns no available day. Priority only — courier is never blocked.
   */
  in_zone_required?: boolean;
}
